import React from 'react';
import styles from './StatTile.module.css';

const intentClass = {
  neutral: styles.intentNeutral,
  success: styles.intentSuccess,
  warning: styles.intentWarning,
  danger:  styles.intentDanger,
};

export default function StatTile({
  label,
  value,
  delta,
  hint,
  intent = 'neutral',
  className = '',
}) {
  return (
    <div className={`${styles.tile} ${className}`}>
      {label && <div className={styles.label}>{label}</div>}
      <div className={`${styles.value} num ${intentClass[intent] ?? ''}`}>
        {value}
      </div>
      {(delta != null || hint) && (
        <div className={styles.meta}>
          {delta != null && (
            <span className={`${styles.delta} num`}>{delta}</span>
          )}
          {hint && <span className={styles.hint}>{hint}</span>}
        </div>
      )}
    </div>
  );
}
